import * as z from 'zod';

export const audienceQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type AudienceQueryLinkerSchema = z.infer<typeof audienceQueryLinkerSchema>;
